import { configResponsive as cr } from "@sundae/react-hooks";
import { Outlet, useLocation } from "@tanstack/react-location";
import cx from "classnames";
import React from "react";

import { ProvidersAfterInitialRender } from "../Providers";
import GradientBackground from "../components/GradientBackground";
import Header from "../components/Header";
import InitialPageTransition from "../components/InitialPageTransition";
import NewsBanner from "../components/NewsBanner/NewsBanner";
import { configResponsive } from "../config/responsive";
import { useIsInitialPageLoad } from "../hooks/useIsInitialPageLoad";
import { usePageviewTracking } from "../hooks/usePageviewTracking";
import { useProfileAppContext } from "../stores";
import { NewsContextProvider } from "../stores/NewsContext";

const MainLayout: React.FC = () => {
  cr(configResponsive);
  const { isInitialPageLoad } = useIsInitialPageLoad();
  const location = useLocation();
  const {
    state: { prefersReducedMotion },
  } = useProfileAppContext();

  usePageviewTracking();

  return (
    <NewsContextProvider>
      <NewsBanner />
      <main
        className={cx("min-h-screen", "dark:bg-gray-900", {
          "overflow-hidden": !location.current.pathname.includes("discover"), // Do not add `overflow-hidden` for Taste Test Pages as it requires sticky behavior
        })}
      >
        <Header />
        <article className="mx-auto mt-[5rem] p-4 xl:mt-[5.5rem] xl:p-6">
          {isInitialPageLoad &&
          !prefersReducedMotion &&
          // disable page transition on dev env
          process.env.NODE_ENV !== "development" ? (
            <InitialPageTransition />
          ) : (
            <ProvidersAfterInitialRender>
              <Outlet />
            </ProvidersAfterInitialRender>
          )}
        </article>
      </main>

      {!isInitialPageLoad && <GradientBackground />}
    </NewsContextProvider>
  );
};

export default MainLayout;
